<template>
    <div class="carBox carBoxLeft" style="flex-direction: column">
        <el-card class="box-card" style="overflow: unset">
            <div slot="header">
                <span>接触式设备监测</span>
            </div>
            <el-table :data="contactList" border stripe>
                <el-table-column label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <div style="border-radius: 4px;background: #67C23A;color: #FFF" v-if="scope.row.state==1">
                            <span>运行</span>
                        </div>
                        <div style="border-radius: 4px;background: #F56C6C;color: #FFF" v-else-if="scope.row.state==2">
                            <span>停机</span>
                        </div>
                        <div style="border-radius: 4px;background: #C0C4CC;color: #FFF" v-else>
                            <span>离线</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="code" label="设备编号"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="alias" label="简称"></el-table-column>
                <el-table-column prop="location" label="所在位置"></el-table-column>
                <el-table-column prop="channel1" label="通道1" align="center">
                    <el-table-column prop="flow1" label="流量(L)">
                        <template slot-scope="scope">
                            {{(scope.row.state==0 && scope.row.flow1==0)?'-':scope.row.flow1}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="pressure1" label="压力(MPa)">
                        <template slot-scope="scope">
                            {{(scope.row.state==0 && scope.row.pressure1==0)?'-':scope.row.pressure1}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="density1" label="密度(g/cm³)">
                        <template slot-scope="scope">
                            {{(scope.row.state==0 && scope.row.density1==0)?'-':scope.row.density1}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column prop="channel2" label="通道2" align="center">
                    <el-table-column prop="flow1" label="流量(L)">
                        <template slot-scope="scope">
                            {{(scope.row.state==0 && scope.row.flow2==0)?'-':scope.row.flow2}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="pressure1" label="压力(MPa)">
                        <template slot-scope="scope">
                            {{(scope.row.state==0 && scope.row.pressure2==0)?'-':scope.row.pressure2}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="density1" label="密度(g/cm³)">
                        <template slot-scope="scope">
                            {{(scope.row.state==0 && scope.row.density2==0)?'-':scope.row.density2}}
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card class="box-card" style="margin-top: 20px;overflow: unset">
            <div slot="header">
                <span>非接触式设备监测</span>
            </div>
            <el-table :data="uncontactList" border stripe>
                <el-table-column label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <div style="border-radius: 4px;background: #67C23A;color: #FFF" v-if="scope.row.state==1">
                            <span>运行</span>
                        </div>
                        <div style="border-radius: 4px;background: #C0C4CC;color: #FFF" v-else>
                            <span>离线</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="code" label="设备编号"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="alias" label="简称"></el-table-column>
                <el-table-column prop="location" label="所在位置"></el-table-column>
                <el-table-column prop="flow1" label="流量(L)">
                    <template slot-scope="scope">
                        {{(scope.row.state==0 && scope.row.flow1==0)?'-':scope.row.flow1}}
                    </template>
                </el-table-column>
                <el-table-column prop="pressure1" label="压力(MPa)">
                    <template slot-scope="scope">
                        {{(scope.row.state==0 && scope.row.pressure1==0)?'-':scope.row.pressure1}}
                    </template>
                </el-table-column>
                <el-table-column prop="density1" label="密度(g/cm³)">
                    <template slot-scope="scope">
                        {{(scope.row.state==0 && scope.row.density1==0)?'-':scope.row.density1}}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { deviceList,realData } from "@/api/moniter";

export default {
    name: 'deviceState',
    data() {
        return {
            m_name: '设备实时状态',
            menu_id: 1500,
            contactList: [],
            uncontactList: [],
        };
    },
    mounted() {
        this.getDeviceList()
    },
    methods: {
        getDeviceList(){
            deviceList().then(res=>{
                if(res.code ==1){
                    this.contactList = res.data.contactList
                    this.uncontactList = res.data.uncontactList
                    this.getRealData()
                }
            })
        },
        getRealData(){
            realData().then(res=>{
                if(res.code ==1){
                    let contactDataList = res.data.contactDataList
                    let uncontactDataList = res.data.uncontactDataList
                    if(contactDataList && this.contactList && contactDataList.length>0 && this.contactList.length>0 && this.contactList.length == contactDataList.length){
                        for(let i=0; i<contactDataList.length; i++){
                            let vo = contactDataList[i]
                            for(let j=0; i<this.contactList.length; j++){
                                let t = this.contactList[j]
                                if(vo.code == t.code){
                                    let volist = vo.data
                                    if(volist.length>0){
                                        let t = volist[volist.length-1]
                                        this.contactList[j].flow1 = t.flow1.toFixed(2)
                                        this.contactList[j].pressure1 = t.pressure1.toFixed(2)
                                        this.contactList[j].density1 = t.density1.toFixed(2)
                                        this.contactList[j].flow2 = t.flow2.toFixed(2)
                                        this.contactList[j].pressure2 = t.pressure2.toFixed(2)
                                        this.contactList[j].density2 = t.density2.toFixed(2)
                                    }
                                    this.contactList[j].state = vo.state
                                    break;
                                }
                            }
                        }
                    }

                    if(uncontactDataList && this.uncontactList && uncontactDataList.length>0 && this.uncontactList.length>0 && this.uncontactList.length == uncontactDataList.length){
                        for(let i=0; i<uncontactDataList.length; i++){
                            let vo = uncontactDataList[i]
                            for(let j=0; j<this.uncontactList.length; j++){
                                let t = this.uncontactList[j]
                                if(vo.code == t.code){
                                    let volist = vo.data
                                    if(volist.length>0){
                                        let t = volist[volist.length-1]
                                        this.uncontactList[j].flow1 = t.flow1.toFixed(2)
                                        this.uncontactList[j].pressure1 = t.pressure1.toFixed(2)
                                        this.uncontactList[j].density1 = t.density1.toFixed(2)
                                    }
                                    this.uncontactList[j].state = vo.state
                                    break;
                                }
                            }
                        }
                    }
                    this.$globalData.timmer1 && clearTimeout(this.$globalData.timmer1)
                    this.$globalData.timmer1 = setTimeout(() => {
                        this.getRealData()
                    }, 1000);
                }else{
                    //this.$msg(res.data)
                }
            })
        },
    }
};
</script>